<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" title="ao.plural"> </sm-page-header>
  <!-- content -->
  <div class="content">
    <sm-data-table-builder
      [dataTableObject]="dataTableObject"
      [totalRecords]="totalRecords"
      [datas]="data"
      [loading]="loading"></sm-data-table-builder>
  </div>
</div>
